import React from 'react'
import { PAGINEDETAIL } from '../../utils/endpoint'
import AboutTemplate from '../../components/template/AboutTemplate/AboutTemplate'
import PropTypes from 'prop-types'
import { getApiClient } from '../../utils'

const About = ({ page, data }) => {
  return (
    <>
      <AboutTemplate page={page} data={data} />
    </>
  )
}

export async function getServerSideProps({ params, locale, req }) {
  const api = getApiClient(req)
  try {
    const pageResponse = await api.get(PAGINEDETAIL, {
      params: {
        chiave: 'about',
        lang: locale,
      },
    })
    const page = pageResponse.data
    const toolbarProps = { toolbarPage: page }
    try {
      const data = await api.get('menu/about/', { params: { lang: locale } })
      const header = data.data
      return { props: { page, ...toolbarProps, data: header } }
    } catch (error) {
      return { props: { page, ...toolbarProps } }
    }
  } catch (error) {
    return { props: { statusCode: 500 } }
  }
}

export default About
